import { Link } from "react-router-dom";
import { ArrowLeft } from "lucide-react";
import { Logo } from "@/components/Logo";

const Shell = ({ title, children }) => (
  <div className="min-h-screen bg-[#F7FAFC]">
    <header className="border-b border-gray-100 bg-white">
      <div className="mx-auto max-w-4xl px-5 sm:px-8 h-16 flex items-center justify-between">
        <Link to="/"><Logo /></Link>
        <Link data-testid="legal-back" to="/" className="inline-flex items-center gap-2 text-sm font-medium text-[#667085] hover:text-[#1677FF]">
          <ArrowLeft size={16} /> Ana Sayfa
        </Link>
      </div>
    </header>
    <main className="mx-auto max-w-3xl px-5 sm:px-8 py-16">
      <h1 className="font-heading text-3xl sm:text-4xl font-bold tracking-tight text-[#172033]">{title}</h1>
      <div className="mt-8 space-y-5 text-[15px] leading-relaxed text-[#475467]">{children}</div>
      <p className="mt-12 text-sm text-[#98A2B3]">Son güncelleme: 2026. Bu metin bir taslaktır ve yürürlüğe girmeden önce güncellenecektir.</p>
    </main>
  </div>
);

export const KvkkPage = () => (
  <Shell title="KVKK Aydınlatma Metni">
    <p>İşbu aydınlatma metni, 6698 sayılı Kişisel Verilerin Korunması Kanunu ("KVKK") kapsamında YıkaGel tarafından hazırlanmıştır.</p>
    <p>Partner başvurusu sırasında paylaştığınız ad-soyad, telefon, e-posta, hizmet bölgesi ve işletme bilgileri; başvurunuzun değerlendirilmesi ve sizinle iletişime geçilmesi amacıyla işlenmektedir.</p>
    <p>Kişisel verileriniz, yalnızca belirtilen amaçlar doğrultusunda ve yasal saklama süreleri boyunca muhafaza edilir; açık rızanız olmadan üçüncü taraflarla pazarlama amacıyla paylaşılmaz.</p>
    <p>KVKK'nın 11. maddesi kapsamında verilerinize erişme, düzeltme ve silme haklarına sahipsiniz. Talepleriniz için bizimle iletişime geçebilirsiniz.</p>
  </Shell>
);

export const GizlilikPage = () => (
  <Shell title="Gizlilik Politikası">
    <p>YıkaGel olarak gizliliğinize önem veriyoruz. Bu politika, web sitemiz üzerinden toplanan bilgilerin nasıl kullanıldığını açıklar.</p>
    <p>Partner başvuru formu aracılığıyla toplanan bilgiler yalnızca başvuru değerlendirme ve iletişim süreçlerinde kullanılır.</p>
    <p>Bilgileriniz uygun teknik ve idari güvenlik önlemleriyle korunur. Onayınız olmadan pazarlama amaçlı üçüncü taraflarla paylaşılmaz.</p>
    <p>Bu politika zaman zaman güncellenebilir. Güncel sürüm her zaman bu sayfada yayınlanır.</p>
  </Shell>
);
